'use client'

import { cookiesDataByName, useCookie } from '@marketplace-web/environment/cookies-util'

import { LOGIN_SELECT_TYPE, REGISTER_SELECT_TYPE } from '../../constants/routes'

const useSelectTypeUrl = () => {
  const cookies = useCookie()

  return cookies.get(cookiesDataByName.last_user_id) ? LOGIN_SELECT_TYPE : REGISTER_SELECT_TYPE
}

export default useSelectTypeUrl
